import React from "react";
import { css } from "@emotion/react";
import { MdClose } from "react-icons/md";

type Props = {
    onClick: () => void,
};

const CloseButton: React.FC<Props> = ({ onClick }) =>  <MdClose css={closeStyle} onClick={onClick}/>;

const closeStyle = css`
    position: absolute;
    right: 4px;
    top: 4px;
    cursor: pointer;
    width: 1.5em;
    height: 1.5em;
`;

export default CloseButton;
